import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFolderAddLeft: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="folder-add-left"><path d="M10.75 19.25H21.25V6.75H12L10 3.75H2.75V11.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M4.75 14.25V17.25V20.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M1.75 17.25H4.75H7.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconFolderAddLeft;
